import { JwtHelperService } from '@auth0/angular-jwt';
import * as i0 from "@angular/core";
var UserService = /** @class */ (function () {
    function UserService() {
        this.jwtHelper = new JwtHelperService();
    }
    Object.defineProperty(UserService.prototype, "contactId", {
        get: function () {
            if (!this.authorizationToken) {
                return null;
            }
            var decodedToken = this.jwtHelper.decodeToken(this.authorizationToken);
            return decodedToken.CONTACT_ID;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UserService.prototype, "authorizationToken", {
        get: function () {
            var re = /OESSOTOK=(.*?)(;|$)/;
            if (!re.test(document.cookie)) {
                return null;
            }
            return re.exec(document.cookie)[1];
        },
        enumerable: true,
        configurable: true
    });
    UserService.ngInjectableDef = i0.defineInjectable({ factory: function UserService_Factory() { return new UserService(); }, token: UserService, providedIn: "root" });
    return UserService;
}());
export { UserService };
